







import {Vue, Component, Prop, Emit} from 'vue-property-decorator';

@Component({
  name: 'MyButton',
})
export default class MyButton extends Vue {
  @Prop() label: string;
  @Prop({
    default: false
  }) disabled: boolean;
  @Prop({
    type: Boolean,
    default: false
  }) isLoading;

  handleClick() {
    this.emitClick();
  }

  @Emit('click')
  emitClick(): void {}
}
